<template>
    <div>
        <div class="card rules-card" v-for="(rule, index) in listingData" :key="index">
            <a class="card-body card-title">
                {{ rule.Title }}
            </a>
            <div v-html="rule.Description" class="description card-body">
            </div>
            <div :id="index"
                 class="collapse show"
                 aria-labelledby="headingOne"
                 data-parent="#accordionExample">
                <div class="card-body">
                    <div class="data">
                        <div class="data__details">
                            <div class="data__details__title">
                                {{ rule.Date }}
                            </div>
                            <div class="data__details__description">
                                <a :href="rule.DownloadUrl" rel="noopener noreferrer" target="_blank">
                                    <img src="../../../../Assets/Images/feather-download.svg"
                                         width="18" alt="Download Icon" />
                                    <span> {{ download }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import moment from "moment";
export default {
    data() {
        return {
            ruleRegulationsArr: []
        }
    },
    props: {
        rulesRegulations: {
            type: Array
        },
        download: {
            type: String
        }
    },
    methods: {},
    computed: {
        listingData() {
            let lang = 'ar'
            if(location.pathname.includes('/en')) {
            lang = 'en'
            }
            let dataArray = JSON.parse(JSON.stringify(this.rulesRegulations))
            dataArray.map((x) => {
                x.Date = moment(new Date(x.Date))
                    .locale(lang)
                    .format("DD - MMM - YYYY");
            });
            return dataArray;
        }
    }
};
</script>
